import { Button, FormDataConsumer, ReferenceInput, required, SelectInput, useNotify } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import dataProvider from "server/dataProvider";
import { activityRequests } from "api/activityApi";
import FormModal from "server/components/Modals/FormModal";

const UpdateForeignLanguageScheduleDialog = ({
  educationId,
  fetchForeignLanguageActivities,
  foreignLanguageActivities,
}) => {
  const notify = useNotify();

  const handleSubmit = async data => {
    const payload = {
      foreignLanguageId: data.foreignLanguageId,
      foreignLanguageLevel: data.foreignLanguageLevel,
    };
    await dataProvider.customRequest(activityRequests.studentForeignLanguageSchedule(educationId), payload, "PUT");
    notify(foreignLanguageActivities ? "Успешно редактирахте ниво на чужд език" : "Успешно добавихте чужд език", {
      type: "success",
    });
    fetchForeignLanguageActivities();
  };

  return (
    <FormModal
      titleContent="Добави разписание за чужд език"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          size="small"
          label={foreignLanguageActivities ? "Редактирай ниво на език" : "Добави език"}
        />
      }
    >
      <ReferenceInput
        reference={activityRequests.getActivityForeignLanguagesSelect()}
        source="foreignLanguageId"
      >
        <SelectInput
          label="Избор на чужд език"
          optionText="name"
          validate={[required()]}
        />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData }) =>
          formData.foreignLanguageId && (
            <ReferenceInput
              key={formData.foreignLanguageId}
              reference={`activity/foreign-languages/${formData.foreignLanguageId}/levels/select`}
              source="foreignLanguageLevel"
            >
              <SelectInput
                label="Ниво на чужд език"
                optionText="name"
                validate={[required()]}
              />
            </ReferenceInput>
          )
        }
      </FormDataConsumer>
    </FormModal>
  );
};

export default UpdateForeignLanguageScheduleDialog;
